import { ReactNode } from 'react';
import { useDrop } from 'react-dnd';

import {
  DragId,
  DragItem,
  DropItem,
  INTERACTIVE_DRAG_DROP,
  InteractiveDragItem,
} from '../../../shared/interactive-drag-drop/interactive-drag-drop.constants';
import {
  InteractiveCategoriseDropItemClickable,
  InteractiveCategoriseDropItemTarget,
} from './interactive-response-categorise-drop.style';

export const InteractiveDrop = ({
  id,
  item,
  children,
  isResponsive,
  onDrop,
  dragItems,
  dropItems,
  isDropZoneSelected,
  isDragItemSelected,
  onDropZoneClicked,
}: {
  id: DragId;
  item: DropItem;
  children?: ReactNode;
  isResponsive?: boolean;
  onDrop: (destinationId: DragId, sourceId: DragId) => void;
  dragItems: DragItem[];
  dropItems: DropItem[];
  isDropZoneSelected?: boolean;
  isDragItemSelected?: boolean;
  onDropZoneClicked?: (id: string) => void;
}) => {
  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: INTERACTIVE_DRAG_DROP,
      drop: (item: InteractiveDragItem) => {
        onDrop(id, item.id);
        return { id };
      },
      collect: monitor => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
      canDrop: () => {
        return item.zones.some(z => z.dragItemId === null);
      },
    }),
    [dragItems, dropItems]
  );

  return (
    <>
      {onDropZoneClicked ? (
        <InteractiveCategoriseDropItemClickable
          ref={node => {
            drop(node);
          }}
          $isOver={canDrop && isOver}
          $canDrop={canDrop}
          $hasDropped={!!children}
          $isResponsive={isResponsive}
          $isOutlined={isDropZoneSelected}
          $isBackgroundHighlighted={!!isDragItemSelected}
          data-drop-zone-clickable="true"
          role="button"
          onClick={() => onDropZoneClicked(id)}
        >
          {children}
        </InteractiveCategoriseDropItemClickable>
      ) : (
        <InteractiveCategoriseDropItemTarget
          ref={node => {
            drop(node);
          }}
          $isOver={canDrop && isOver}
          $canDrop={canDrop}
          $hasDropped={!!children}
          $isResponsive={isResponsive}
        >
          {children}
        </InteractiveCategoriseDropItemTarget>
      )}
    </>
  );
};
